import React from "react";
import Header from "./layers/Header";
import Footer from "./layers/Footer";

const AboutUs = () => {
  return (
    <>
      <Header />

      <section className="bg-white py-20">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h1 className="text-4xl font-bold text-[#1E0E62] mb-6">
            About ZaviraMed
          </h1>

          <p className="text-lg text-[#1E0E62]/70 leading-relaxed mb-6">
            ZaviraMed is a platform built for licensed doctors to provide virtual consultations,
            messaging, and follow-ups while connecting with patients, HMOs, and healthcare organizations.
            Our mission is to empower doctors to work independently, transparently, and securely.
          </p>

          <p className="text-lg text-[#1E0E62]/70 leading-relaxed">
            We focus on giving doctors flexibility, secure earnings, and peace of mind
            while patients get access to qualified medical professionals anytime, anywhere.
          </p>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default AboutUs;